import { ArrowRightLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";
import { parseDirection, SCRIPT_LABEL_KEY, SCRIPTS } from "~/utils/direction";

interface DirectionSwitcherProps {
  selectedDirection: string;
  onFromLanguageChange: (key: string) => void;
  onToLanguageChange: (key: string) => void;
  onDirectionSwap: () => void;
  readOnly?: boolean;
  className?: string;
}

export function DirectionSwitcher({
  selectedDirection,
  onFromLanguageChange,
  onToLanguageChange,
  onDirectionSwap,
  readOnly = false,
  className = "",
}: DirectionSwitcherProps) {
  const { t } = useTranslation();
  const { from, to } = parseDirection(selectedDirection);

  const options = SCRIPTS.map((script) => (
    <SelectItem key={script} value={script}>
      {t(SCRIPT_LABEL_KEY[script])}
    </SelectItem>
  ));

  return (
    <div className={`flex items-center gap-2 bg-gray-100 ${className}`}>
      <Select
        value={from}
        disabled={readOnly}
        onValueChange={(value) => onFromLanguageChange(value)}
      >
        <SelectTrigger className="flex-1 bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>{options}</SelectGroup>
        </SelectContent>
      </Select>

      <Button
        variant="outline"
        className="px-2"
        onClick={onDirectionSwap}
        disabled={readOnly}
      >
        <ArrowRightLeft />
      </Button>

      <Select
        value={to}
        disabled={readOnly}
        onValueChange={(value) => onToLanguageChange(value)}
      >
        <SelectTrigger className="flex-1 bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>{options}</SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
